import React from 'react';
import { cutString } from '../../utils/Generator';
import { useMediaQuery } from '@material-ui/core';
import { Link } from 'react-router-dom';
import './HistoryStateArrows.scss';

const HistoryStateArrows = ({
    filterCategories,
    dataToFilter,
    firstWord,
    limitCategory,
    limitTitle,
    principalFunction,
    secondaryFunction
}) => {

    const isMobile = useMediaQuery('(max-width: 768.98px)')

    const firstWordClick = async () => {
        if (principalFunction) {
            await principalFunction()
        }
        filterCategories({
            category: '',
            title: ''
        })
    }

    const secondWordClick = async () => {
        if (secondaryFunction) {
            await secondaryFunction(dataToFilter.category)
        }
        filterCategories({
            category: dataToFilter.category,
            title: ''
        })
    }

    return (
        <ol
            itemScope
            itemType='http://schema.org/BreadcrumbList'
            className='HistoryStateArrows_history'
        >   
            <li
                itemScope
                itemProp="itemListElement"
                itemType="http://schema.org/ListItem"
                className='HistoryStateArrows_history-first'
            >
                <Link
                    className='HistoryStateArrows_history-first'
                    itemProp="item"
                    to='/asuntos-legales'
                    onClick={firstWordClick}
                >
                    <span itemProp="name">{firstWord}</span>
                </Link>
                <meta itemProp="position" content="1" />
            </li>

            {dataToFilter && dataToFilter.category ? 
                <li
                    itemScope
                    itemProp="itemListElement"
                    itemType="http://schema.org/ListItem"
                >
                    <img
                        alt='back'
                        src='/img/arrows/arrow-right.svg'
                        className='HistoryStateArrows_history-arrowRight'
                    />
                    <Link
                        itemProp="item"
                        className={
                            dataToFilter && dataToFilter.title ?
                            'HistoryStateArrows_history-start' :
                            'HistoryStateArrows_history-last'
                        }
                        onClick={secondWordClick}
                        to={`/asuntos-legales/${dataToFilter.category}`}
                    >
                        <span itemProp="name">
                            {isMobile ?
                                cutString(limitCategory, dataToFilter.category) :
                                dataToFilter.category
                            }
                        </span>
                        <meta itemProp="position" content="2" />
                    </Link>
                </li> : null
            }
            {dataToFilter && dataToFilter.title ? 
                <li
                    itemScope
                    itemProp="itemListElement"
                    itemType="http://schema.org/ListItem"
                >
                    <img
                        alt='back'
                        src='/img/arrows/arrow-right.svg'
                        className='HistoryStateArrows_history-arrowRight'
                    />
                    <Link
                        itemProp="item"
                        className='HistoryStateArrows_history-last'
                    >
                        <span itemProp="name">
                            {isMobile ?
                                cutString(limitTitle, dataToFilter.title) :
                                dataToFilter.title
                            }
                        </span>
                        <meta itemProp="position" content="3" />
                    </Link>
                </li> : null
            }
        </ol>
    )
}

export default HistoryStateArrows;
